import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ViewTaasPayDto } from 'src/app/web/interfaces/taas/list/viewTaasPayDto';

@Component({
  selector: 'app-pay-popup-hes',
  templateUrl: './pay-popup-hes.component.html',
  styleUrls: ['./pay-popup-hes.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class PayPopupHesComponent implements OnInit {

  closeResult = '';
  item: ViewTaasPayDto

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  
  constructor(config: NgbModalConfig, private modalService: NgbModal) {

    config.backdrop = 'static';
    config.keyboard = false;
   }

  ngOnInit(): void {

  }

  public open(itemEnd: ViewTaasPayDto, type: string) {


    if(type == "pay"){
      this.item = itemEnd
    }

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
